import Validator from "validator";

export const point_of_contact_error_check = (state, errorBoolean) => {
  let errors = {};

  state.firstName = !isEmpty(state.firstName) ? state.firstName : "";
  state.lastName = !isEmpty(state.lastName) ? state.lastName : "";
  state.selected_position = !isEmpty(state.selected_position)
    ? state.selected_position
    : "";
  state.position = !isEmpty(state.position) ? state.position : "";
  // contacts_array,enquiry_emails, phone_numbers

  // SINGLE ARRAY
  if (Validator.isEmpty(state.firstName)) {
    errors.firstName = "First Name is Required!!!";
  }
  if (Validator.isEmpty(state.lastName)) {
    errors.lastName = "Last Name is Required!!!";
  }
  if (Validator.isEmpty(state.selected_position)) {
    errors.selected_position = "Please Provide a valid postion";
  }
  if (
    state.selected_position === "Other" &&
    Validator.isEmpty(state.position)
  ) {
    errors.position = "position is required";
  }
  // if (Validator.isEmpty(state.position)) {
  //   errors.position = "position is required";
  // }
  if (
    Validator.isEmpty(state.enquiry_emails[0]) ||
    !Validator.isEmail(state.enquiry_emails[0])
  ) {
    errors.email = "Invalid email address";
  }
  if (
    Validator.isEmpty(state.phone_numbers[0].mobile_no) ||
    !Validator.isLength(state.phone_numbers[0].mobile_no, { min: 10, max: 10 })
  ) {
    errors.mobile_no = "Invalid mobile number";
  }

  if (
    state.firstName === "" &&
    state.lastName === "" &&
    state.selected_position === "" &&
    state.position === "" &&
    state.contacts_array.length > 0 &&
    state.enquiry_emails[0] === "" &&
    state.phone_numbers[0].mobile_no === ""
  ) {
    errors = {};
  }
  return !isEmpty(errors) ? true : false;
};

/**
 * Returns true if the value is undefined/null/empty object/empty string.
 *
 * @param value
 * @return {boolean}
 */
export const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);
